import {
  showToast,
  hideToast,
  showLoading,
  hideLoading
} from '@/plugins/environment/model/toast' // 轻提示+loading
import { showNotify, hideNotify } from '@/plugins/environment/model/notify' // 通知
import { showDialog, hideDialog } from '@/plugins/environment/model/dialog' // 弹框
import { picturePreview } from '@/plugins/environment/model/other' // 其他
import { routerPush, shareGoods, pop, refresh, backHome, backUser } from '@/plugins/environment/model/remould-router'
import { initJpush, setAlias, onClearBadge } from '@/plugins/environment/model/jpush' // 极光推送
import { initApprate } from '@/plugins/environment/model/appRate' //  App评分

export const typeName = {
  showToast,
  hideToast,
  showLoading,
  hideLoading,
  showNotify,
  hideNotify,
  showDialog,
  hideDialog,
  routerPush,
  shareGoods,
  pop,
  picturePreview,
  refresh,
  backHome,
  backUser,
  setAlias,
  onClearBadge,
  initJpush,
  initApprate
}
